// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"4487a1dd","34":"4487a1dd","51":"4487a1dd","68":"4487a1dd","74":"4487a1dd","88":"1290cfad","343":"f5f2240b","386":"2e9dd1b5","493":"4487a1dd","613":"b08ba1f6","620":"04b29f1b","854":"4487a1dd","991":"a1583d7b"}[chunkId] + ".chunk.css";
};